import { extend } from '../../vue';
import { NAME_TH } from '../../constants/components';
import { makePropsConfigurable } from '../../utils/props';
import { props as props$1, BTd } from './td';

// --- Props ---

const props = makePropsConfigurable(props$1, NAME_TH);

// --- Main component ---

// TODO:
//   In Bootstrap v5, we won't need "sniffing" as table element variants properly inherit
//   to the child elements, so this can be converted to a functional component
// @vue/component
const BTh = /*#__PURE__*/extend({
  name: NAME_TH,
  extends: BTd,
  props,
  computed: {
    tag() {
      return 'th';
    }
  }
});

export { BTh, props };
